import { createAction } from 'typesafe-actions';
import { ACTIONS } from './types';

export const changeCommissionModeAction = createAction(ACTIONS.CHANGE_COMMISSION_MODE)();
export const setCommissionModeAction = createAction(ACTIONS.SET_COMMISSION_MODE)<boolean>();
